/*
	Licensed Materials - Property of IBM
	IBM Business Analytics (C) Copyright IBM Corp. 2022
	US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/

define([], function() {

	return class FeatureFlagUtils {

		/**
		 * The generateChecker method returns a function used to set a property to an instance object.
		 * @param {DashboardAPI} dashboard
		 * @param {object} instance An instance of an object/class to add the property to
		 * @returns {function} A function that the developer uses to set a property on the given instance object.
		 *
		 * @example
		 * const addCheck = FeatureFlagUtils.generateChecker(dashboard, this);
		 * addCheck('_aPropertyFlag', ['dashboard', 'SomeFeatureFlagName', 'enabled']);
		 * if (this._aPropertFlag) {
		 * 	// do something
		 * }
		 *
		 * the above results with 'this` having an instance property that uses the glass FeatureChecker service to get the value
		 * of the passed rule depending on whether the rule has been added to the FeatureChecker or not.
		 *
		 * this._aPropertyFlag = true|false;
		 *
		 * The nice thing is that the instance property is a get method. This means that the FF rule will be re-evaluated at runtime.
		 * This allows us to change FF value without needing to reload anything.
		 */
		static generateChecker(dashboard, instance) {
			return function(propertyName, rule) {
				// Ensure the instance doesn't already have a property of the name
				if (instance.hasOwnProperty(propertyName)) {
					return;
				}

				Object.defineProperty(instance, propertyName, { get: function() {
					let value;
					try {
						value = dashboard
							.getGlassCoreSvc('.FeatureChecker')
							.checkValue(...rule);
					} catch(e) {
						value = false;
					}

					return value;
				} });
			};
		}
	};

});
